import PPDecimalInput from "../../../common/PPDecimalInput"
import { parseDecimalInput } from "../../../common/decimalInputConfig"

export const finiteNumberOrZero = (value) => parseDecimalInput(value)

export function convertToServerOperator(op) {
     switch (op) {
          case "+":
               return "PLUS"
          case "-":
               return "MINUS"
          case "*":
               return "MULTIPLICATION"
          case "/":
               return "DIVISION"
          default:
               return op
     }
}

export function formulaRowKey(formula) {
     if (formula?.id != null) {
          return String(formula.id)
     }
     return JSON.stringify(formula)
}

const WEEKDAY_TO_JS = {
     SONNTAG: 0,
     MONTAG: 1,
     DIENSTAG: 2,
     MITTWOCH: 3,
     DONNERSTAG: 4,
     FREITAG: 5,
     SAMSTAG: 6,
}

function dateMatchesTurnus(date, turnus, weekdaySet, monthdaySet) {
     const weekdayOk = weekdaySet.size === 0 || weekdaySet.has(date.getDay())
     if (turnus === "WOECHENTLICH") {
          return weekdayOk
     }
     if (turnus === "MONATLICH" || turnus === "JAEHRLICH") {
          const monthdayOk = monthdaySet.size === 0 || monthdaySet.has(date.getDate())
          return weekdayOk && monthdayOk
     }
     return false
}

export function computeNextExecutionDate(currentTurnus, firstDate, lastDate, selectedWeekdays, selectedMonthdays) {
     if (!currentTurnus) {
          return null
     }
     const today = new Date()
     today.setHours(0, 0, 0, 0)
     const startDate = firstDate && firstDate > today ? firstDate : today
     const weekdaySet = new Set((selectedWeekdays || []).map((day) => WEEKDAY_TO_JS[day]).filter((day) => day !== undefined))
     const monthdaySet = new Set(
          (selectedMonthdays || []).map((day) => Number(day)).filter((day) => Number.isInteger(day) && day >= 1 && day <= 31)
     )
     for (let i = 0; i < 3660; i++) {
          const candidate = new Date(startDate)
          candidate.setDate(startDate.getDate() + i)
          if (lastDate && candidate > lastDate) {
               return null
          }
          if (dateMatchesTurnus(candidate, currentTurnus, weekdaySet, monthdaySet)) {
               return candidate
          }
     }
     return null
}

export const selectedOption = (options, value) => {
     const scalar = typeof value === "object" ? (value?.value ?? value?.label) : value
     return options.find((option) => option.value === scalar) || null
}

export function FormulaDecimalInput({ value, onChange, suffix, decimalsLimit = 4, style }) {
     const numericValue = value !== undefined && value !== null && !Number.isNaN(Number(value)) ? value : 0
     return (
          <PPDecimalInput
               className="form-control"
               style={style ?? { width: "100px" }}
               value={numericValue}
               onValueChange={(v) => onChange(parseDecimalInput(v))}
               decimalsLimit={decimalsLimit}
               disableGroupSeparators
               allowNegativeValue
               suffix={suffix}
          />
     )
}
